'use strict';

angular.module('msUtility').service('dateTimeSvc', dateTimeSvc);

function dateTimeSvc() {
  function getHoursBetweenJavaTimes(beginTime, endTime) {
    var beginHr = beginTime[0];
    var endHr = endTime[0];
    var begin = moment().set('hour', beginHr).set('minute', beginTime[1]);
    var end = moment().set('hour', endHr).set('minute', endTime[1]);
    if (end.isBefore(begin, 'minute')) {
      //let's assume the end is on the next day
      end.add(1, 'days');
    }
    //return duration in hours, rounded to 2 decimal places
    return _.round(moment.duration(end.diff(begin)).asHours(), 2);
  }

  //get Java time and return in Java time after adding minutes
  function getTimeAfterMinutesAdded(time, minutes) {
    var timeObj = moment().set('hour', time[0]).set('minute', time[1]);
    timeObj.add(_.toNumber(minutes), 'minutes');
    return [timeObj.hour(), timeObj.minutes()];
  }

  return {
    getHoursBetweenJavaTimes: getHoursBetweenJavaTimes,
    getTimeAfterMinutesAdded: getTimeAfterMinutesAdded
  };
}